import { Box, Stack } from '@mui/material'
import { tasksSelectOneFieldById } from "@common-reducers/DBServiceThunks"
import { getIsShowSubTasks, getOneFieldFromTaskGroupByTaskId, isLastTaskInGroup } from '@common-reducers/TaskSelectors'
import { checkIfMenuActiveTaskIdInBulkAction } from '@common-reducers/TaskThunks'
import { taskActions } from '@common-reducers/TasksReducer'
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { DEFAULT_ACCENT_COLOR } from '@common/theme/colors'
import classes from "../../task-row/task_row.module.scss"
import { CellProps } from '../cell-interface'
import TaskMenu from '../../task-menu/task-menu';

export default function RowMenuCell({
    taskId,
    isOnKanban,
}: CellProps) {
    // const dispatch = useAppDispatch()
    // const menuActiveTaskId = useAppSelector((state) => state.TasksReducer.menuActiveTaskId)
    const colorAccent = useAppSelector((state) => getOneFieldFromTaskGroupByTaskId({ state, taskId: taskId ?? "", field: 'colorAccent' }) as string | undefined)
    const isLastInGroup = useAppSelector((state) => isLastTaskInGroup(state, taskId))
    const parentTaskId = useAppSelector((state) => tasksSelectOneFieldById(state.DBTasksReducer, taskId, "parentTaskId"))
    const isSubtask = parentTaskId ? true : false;
    const isShowSubTasks = useAppSelector((state) => getIsShowSubTasks({ state, taskId: taskId ?? "" }))
    const color = colorAccent ?? DEFAULT_ACCENT_COLOR;
    const direction = useAppSelector((state) => state.UserReducer.direction);

    const currentDraggedId = useAppSelector((state) => state.TasksReducer.currentDraggedId)

    return (
        <Stack direction="row" alignItems="center">
            <Box>
                <Stack
                    alignItems="center"
                    width={!isOnKanban ? 40 : 24}
                    className={
                        classes.task_row_menu_button + " " +
                        (isOnKanban ? classes.task_row_menu_button_in_kanban : "")
                    } 
                 >
                    <TaskMenu taskId={taskId ?? ""} />
                </Stack>
            </Box>
            {!isOnKanban ? (
                <Stack alignItems="center"
                    style={{
                        height: isLastInGroup && !isShowSubTasks ? 39 : 40,
                        backgroundColor: isSubtask ? "var(--color-surface)" : color,
                        width: isSubtask ? 3 : isLastInGroup && !isShowSubTasks ? 24 : 5,
                        flexShrink: 0,
                        position: 'relative',
                        insetInlineStart: isSubtask ? 2 : 0,
                        borderInlineStart: isSubtask ? `2px solid ${color}` : "none",
                        borderBottomLeftRadius: direction === 'ltr' ? (!isSubtask && isLastInGroup && !isShowSubTasks && currentDraggedId !== taskId ? 12 : undefined) : undefined,
                        borderBottomRightRadius: direction === 'rtl' ? (!isSubtask && isLastInGroup && !isShowSubTasks ? 12 : undefined) : undefined
                    }}>
                </Stack>) : ""}
        </Stack >
    )
}